/**
 * Extract designId from PDP product slug.
 * Example: "rose-ring~12345.html" → "12345"
 */
export function getDesignIdFromSlug(productSlug: string): string {
  const withoutHtml = productSlug.replace(/\.html$/, '');
  const parts = withoutHtml.split('~');
  return parts[parts.length - 1] ?? '';
}

/** Ensure product page URLs are root-relative so nested PDP paths don't duplicate segments. */
export function normalizeProductPageUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('http')) return trimmed;
  if (trimmed.startsWith('/')) return trimmed;
  return `/${trimmed.replace(/^\/+/, '')}`;
}

/** Pathname from API canonical / share URL (`__BASE_URL__/x.html` or absolute). */
export function getCanonicalPathname(raw: string | null | undefined): string | null {
  if (!raw?.trim()) return null;
  try {
    return new URL(
      raw.trim().replace(/__BASE_URL__/g, 'https://www.bluestone.com'),
      'https://www.bluestone.com'
    ).pathname;
  } catch {
    return null;
  }
}
